import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { CompraService } from '../../services/compra.service';
import { Router } from '@angular/router';
import * as $ from 'jquery';

class Usuario {
  correo: string;
  contrasena: string;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {


  showError: boolean;
  formValido: any;
  userSession: any;
  title = "Login";
  usuario: Usuario;
  mensaje: string = "";
  hola = "¡Hola!";
  bienvenida = "En dReaMZ nos interesa personalizar tu experiencia de compra, por lo que te pedimos le des clic al botón que mejor te describa.";
  categorias: any = [];
  perfiles: any = [];
  perfil: any;
  texto: any;
  productos: any = [];
  categoria: any = [];

  constructor(public consultaService: ConsultaService, private router: Router,
    public compraService: CompraService) { }

  ngOnInit() {
    this.initUsuario();
  }

  initUsuario() {
    this.usuario = new Usuario();
    this.usuario.contrasena = "";
    this.usuario.correo = "";

  }

  isValidForm() {
    var valido = true;
    if (this.usuario.correo.length == 0 || this.usuario.contrasena.length == 0) {
      valido = false;
    }
    return valido;
  }

  ngAfterViewInit() {

    if(!this.consultaService.esNuevaSession()){
      this.router.navigate(['/home']);
    }else{
        $("#btn_open_modal_perfiles").click();
    }

  }

  /**
   * Navega a la vista home de la aplicacion
   */
  validarCredenciales(): any {
    this.showError = false;
    this.consultaService.validarCredenciales(this.usuario).then(resolve => {
      this.userSession = this.consultaService.userSession;
      if (this.userSession.error == true) {
        this.showError = true;
        this.mensaje = this.userSession.mensaje;
      } else {
        this.mensaje = "";
        $("#btn_open_modal_perfiles").click();
        this.router.navigate(['/home']);
      }
    });
  }

  /**
   * Elimina las variables de session
   */
  cerrarSesion() {
    this.validaTamanioExplorador();
    this.consultaService.cerrarSesion();
    $("#btn_open_modal_perfiles").click();
    this.router.navigate(['/perfil']);
  }

  validaTamanioExplorador(){
    if(Number(window.innerWidth)<=990){
      $('#botonMenuPhone').click();
    }
  }

}//end class



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/navbar/navbar.component.ts